import { HTTP_GET_METHOD, HTTP_POST_METHOD } from "../constants";

export const endpoints = {
  auth: {
    Login: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/back-office/auth/login",
    },
    Logout: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/back-office/auth/logout",
    },
    ForgetPassword: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/back-office/auth/forget",
    },
    ResetPassword: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/back-office/auth/reset",
    },
  },
  TeleversUserApi: {
    GetSignMessage: {
      method: HTTP_GET_METHOD,
      url: "/auth/sign-message",
    },
    LoginByAddress: {
      method: HTTP_POST_METHOD,
      url: "/auth/login-by-address",
    },
    RegisterCheckUserAddress: {
      method: HTTP_POST_METHOD,
      url: "/auth/register-check",
    },
    Logout: {
      method: HTTP_POST_METHOD,
      url: "/auth/logout",
    },
  },
  ProfileData: {
    GetProfileData: {
      method: HTTP_GET_METHOD,
      url: "/profile/data",
    },
    UpdateProfile: {
      method: HTTP_POST_METHOD,
      url: "/profile/update",
    },
    changeAvatarCover: {
      method: HTTP_POST_METHOD,
      url: "/profile/change-image",
    },
    SetSponsorAddress: {
      method: HTTP_POST_METHOD,
      url: "/profile/set-sponsor-address",
    },
  },
  Users: {
    GetNames: {
      method: HTTP_POST_METHOD,
      url: "/users/get-names",
    },
  },
  TrinityUsers: {
    List: {
      method: HTTP_GET_METHOD,
      url: "/trinity-users",
    },
    Add: {
      method: HTTP_POST_METHOD,
      url: "/trinity-users",
    },
  },
  Following: {
    GetUsers: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/follow/get-users",
    },
    GetFollowings: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/follow/get-followings",
    },
    GetFollowers: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/follow/get-followers",
    },
    Follow_UnFollow: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/follow/follow-unfollow",
    },
  },
  Event: {
    GetCategories: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/event/get-categories",
    },
    CreateEvent: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/event/create",
    },
    Attend: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/event/attend",
    },
    GetAll: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/event/get-all",
    },
    GetEvent: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/event/get",
    },
  },
  Nft: {
    GetNft: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/nft/get",
    },
    GetTopNft: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/nft/get-top",
    },
    GetFilter: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/nft/get-filter",
    },
    GetOwners: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/nft/get-owners",
    },
  },
  Marketplace: {
    GetAll: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/marketplace/get-all",
    },
    GetItem: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/marketplace/get",
    },
    Favorite: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/marketplace/favorite",
    },
    GetFavorite: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/marketplace/get-favorite",
    },
  },
  Televers: {
    GetAll: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/televers/get-all",
    },
    GetEvent: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/televers/get",
    },
    GetWeekEvents: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/televers/week-events",
    },
  },
  Notifications: {
    GetNotifications: {
      method: HTTP_GET_METHOD,
      url: "/api/v1/notifications/get",
    },
    ReadNotification: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/notifications/read",
    },
    DeleteNotification: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/notifications/delete",
    },
  },
  Reports: {
    Create: {
      method: HTTP_POST_METHOD,
      url: "/api/v1/report/create",
    },
  },
};
